import React, {useContext, useEffect, useState} from 'react'
import FormularioRecargarCuentaServicios from '../../componentes/usuarioContable/FormularioRecargarCuentaServicios'
import {ContextoRecargarSaldo, ContextoAplicacion} from '../../contexto'
import {RecargarSaldoCuenta} from '../../microservicios'
import {useNavigate} from 'react-router-dom'
import useValidacionTransaccionPendiente from '../../componentes/usuarioContable/ValidacionTransaccionPendiente'
import {obtenerUrlRedirect} from '../../config'
import {ObtenerCiudadPorId} from '../../cache/servicios-cache'
import {useFeatureIsOn} from '@growthbook/growthbook-react'
import {TEXTO_FEATURE_FLAGS} from '../../constantes/featureFlags'
import {BotonSimple} from '../../componentes/Botones'
import {aplicarFormatoMoneda} from '../../utils'

const RecargarSaldo = () => {
  useValidacionTransaccionPendiente()

  const habilitarRecargarCuenta = useFeatureIsOn(
    TEXTO_FEATURE_FLAGS.REALIZAR_PAGOS_PORTAL_CLIENTE
  )

  const contextoAplicacion = useContext(ContextoAplicacion)
  const contextoRecargarSaldo = useContext(ContextoRecargarSaldo)
  const [urlApp, setUrlApp] = useState('')
  const navigate = useNavigate()

  const idEmpresa = contextoAplicacion.infoEmpresa.id ?? 0

  const [ip, setIp] = useState('')

  function obtenerDireccionIP() {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => {
        setIp(data.ip)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    obtenerDireccionIP()
  }, [])

  useEffect(() => {
    obtenerUrlRedirect()
      .then((response) => {
        setUrlApp(response)
      })
      .catch((err) => {
        console.error('no se pudo obtener la url de redireccion', err)
      })
  }, [])

  const mostrarModalConfirmacion = (montoRecarga, valorRecibido) => {
    return new Promise((resolve) => {
      contextoAplicacion.setModal({
        abierto: true,
        titulo: '',
        contenido: (
          <>
            <div className="text-center w-full mb-10 flex justify-center items-center flex-wrap">
              <span className="w-full text-center text-cendiatra-verde-2 text-2xl font-bold uppercase">
                SE REALIZARÁ LA RECARGA PARA:
              </span>
              <span className="w-full text-center text-cendiatra-verde-2 text-2xl font-bold uppercase mt-5">
                {contextoAplicacion.infoEmpresa.nombre}
              </span>
              <span className="w-full text-center text-cendiatra-verde-2 text-lg font-bold normal-case mt-12">
                Monto a recargar {aplicarFormatoMoneda(montoRecarga)}
              </span>
              <span className="w-full text-center text-cendiatra-verde-3 text-lg  normal-case mt-10 ">
                Verificar que la información sea correcta antes de continuar
              </span>
              <div className="w-full flex justify-center items-center mt-10 -mb-24">
                <BotonSimple
                  texto={'Regresar'}
                  estilosBoton={`w-28 h-10 p-1.5 gap-2 flex items-center justify-center rounded-lg bg-white text-cendiatra-verde-3 underline text-lg mx-25px`}
                  funcion={() => {
                    manejarCerrarModal()
                    resolve(false)
                  }}
                />
                <BotonSimple
                  texto={'Continuar'}
                  estilosBoton={`w-28 h-10 p-1.5 gap-2 flex items-center justify-center rounded-lg bg-fondoBoton bg-cover bg-no-repeat bg-center text-white text-lg mx-25px`}
                  funcion={() => {
                    manejarCerrarModal()
                    resolve(true)
                  }}
                />
              </div>
            </div>
          </>
        ),
        clasesAdicionales: 'w-5/12 border border-cendiatra',
        botones: [],
      })
    })
  }

  const enviarInformacionRecarga = async (
    datosTabla,
    municipio,
    totalTabla
  ) => {
    const confirmado = await mostrarModalConfirmacion(
      parseFloat(datosTabla?.montoRecarga?.toFixed(2)),
      parseFloat(totalTabla.toFixed(2))
    )
    if (!confirmado) return
    const medioDePagoPSE = 3
    const payload = {
      empresaId: idEmpresa,
      valor: parseFloat(datosTabla?.montoRecarga?.toFixed(2)),
      valorRecibido: parseFloat(totalTabla.toFixed(2)),
      detalleRecarga: contextoRecargarSaldo.formularioRecargarSaldo.detalle,
      ip: ip,
      UrlRetornoComercio: urlApp,
      municipioId: municipio?.MunicipioId,
      retefuente: datosTabla?.retencionRenta || 0,
      reteIca: datosTabla?.retencionICA || 0,
      bomberil: datosTabla?.sobretasaBomberil || 0,
      mediosDePago: [
        {
          medioPagoId: medioDePagoPSE,
          valor: parseFloat(totalTabla?.toFixed(2)),
        },
      ],
      numeroCuenta: municipio.Id === 1 ? null : municipio.Id,
      municipio: municipio.Nombre,
    }
    recargarSaldo(payload)
  }

  async function recargarSaldo(payload) {
    try {
      const res = await RecargarSaldoCuenta(payload)
      if (res.data) {
        const empresaData = {
          documento: contextoRecargarSaldo.dataPdf.documento,
          nombre: contextoRecargarSaldo.dataPdf.nombre,
          direccion: contextoRecargarSaldo.dataPdf.direccion,
          telefono: contextoRecargarSaldo.dataPdf.telefono,
          municipio:
            (await ObtenerCiudadPorId(payload.municipioId ?? 0))?.Nombre ?? '',
        }

        sessionStorage.setItem('movimientoId', res?.data?.movimientoId)
        sessionStorage.setItem('empresaData', JSON.stringify(empresaData))

        const urlAvalPay = res?.data?.urlPasarelaPagos
        window.open(urlAvalPay, '_self')
      }
    } catch (error) {
      manejarModalError()
    }
  }

  const manejarCerrarModal = () => {
    contextoAplicacion.setModal({
      abierto: false,
      titulo: '',
      contenido: '',
      botones: [],
    })
  }

  const irAInicio = () => {
    manejarCerrarModal()
    navigate('/')
  }

  const manejarModalError = () => {
    contextoAplicacion.setModal({
      abierto: true,
      titulo: 'ERROR',
      contenido: (
        <div className="w-full flex justify-center items-center text-cendiatra text-3xl my-10 font-bold flex-wrap">
          <span className="w-full">Tu cuenta NO ha sido recargada</span>
          <span className="w-full">¿Qué deseas hacer?</span>
        </div>
      ),
      botones: [
        {
          nombre: 'Regresar a recargar cuenta',
          click: () => manejarCerrarModal(),
        },
        {
          nombre: 'Finalizar',
          click: () => irAInicio(),
        },
      ],
    })
  }

  return (
    <div className="w-full pt-10 pb-10">
      {/* <div className="w-full flex justify-center items-center">
        <img
          className="w-auto h-700px"
          src="https://prodcendiatra.blob.core.windows.net/staticweb/imagen.png"
          alt=""
        />
      </div> */}
      <div className="container mx-auto flex justify-center">
        <div className="w-9/12 flex">
          <div className="w-full flex flex-wrap justify-center items-center">
            <h4 className="text-center text-cendiatra text-3xl font-bold w-full">
              RECARGA TU CUENTA DE SERVICIOS
            </h4>
            <h4 className="text-center text-cendiatra text-3xl font-bold w-full">
              {contextoAplicacion.infoEmpresa.nombre}
            </h4>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <FormularioRecargarCuentaServicios
          manejarGuardar={enviarInformacionRecarga}
        />
      </div>
    </div>
  )
}

export default RecargarSaldo
